module.exports = __webpack_public_path__ + "7c37c2e2e15c907b9b1721cca9e16add.png";